
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios'
import {message} from 'antd'
import keyUri from '../../key'

export const initialState = {

    loading: false,
    hasErrors: false,
    events:[],
    currentevents:null,
}

export const eventsSlice = createSlice({
    name:"events",
    initialState,
    reducers:{

        getEvents: state =>{

            state.loading = true
        },

        getEventsSuccess: (state, {payload}) =>{
            state.loading = false
            state.events = payload
            
        },

        getCurrentEvents: (state, {payload}) =>{
          console.log({k:payload});

            state.loading = false
            state.currentevents = payload
            
        },
        getEventsFailure: (state, {payload}) =>{

            state.loading = false
            state.events = payload
            
        },

    }
})

export const {getEvents, getEventsSuccess, getCurrentEvents, getEventsFailure } = eventsSlice.actions
      
export const eventsSelector = state => state.events
export default eventsSlice.reducer


const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };



export const  fetchAllEvents = () => async dispatch =>{
      const key = "events"
      dispatch(getEvents())
      
    try {

        const {data} = await axios.get(keyUri.BACKEND_URI +'/events');
        console.log(data)
        dispatch(getEventsSuccess(data))

    } catch ({response}) {

        dispatch(getEventsFailure())
        response.data && message.error({ content: response.data.msg, key, duration: 2 });

    }
    
}

export const  fetchOneEvents = (id) => async dispatch =>{

    dispatch(getEvents())
    
  try {

      const {data} = await axios.get(keyUri.BACKEND_URI +`/event/${id}`);
      dispatch(getCurrentEvents(data))

  } catch ({response}) {

      dispatch(getEventsFailure())
    //   response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  createEvents = (values) => async dispatch =>{
  console.log(values);
    const key = "events"
    dispatch(getEvents())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.post(keyUri.BACKEND_URI +'/events', values, config);
      console.log(data)
      setTimeout(() => {

        message.success({ content: data.msg, key, duration: 2 });
      }, 500) 
        // dispatch(fetchAllEvents())

  } catch ({response}) {
       dispatch(getEventsFailure())
  }
  
}


export const  deleteEvents = (id) => async dispatch =>{
    const key = "events"
    dispatch(getEvents())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.delete(keyUri.BACKEND_URI +`/events/${id}`);
      data && message.success({ content: data.msg, key, duration: 2 });
      dispatch(fetchAllEvents())

  } catch ({response}) {

      dispatch(getEventsFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  updateEvents = (id, values) => async dispatch =>{
    const key = "events"
    dispatch(getEvents())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.put(keyUri.BACKEND_URI +`/events/${id}`, values, config);
      data && message.success({ content: data.msg, key, duration: 2 });
      window.location.reload()
      dispatch(fetchAllEvents())

  } catch ({response}) {

      dispatch(getEventsFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}




